/**
 * Helper function to convert wei to token amount
 * @param wei - The amount in wei (smallest unit)
 * @param decimals - The number of decimal places for the token
 * @returns The token amount as a string
 */
export function weiToTokenAmount(wei: string, decimals: number | bigint): string {
  const decimalsNum = typeof decimals === "bigint" ? Number(decimals) : decimals;

  return (parseInt(wei) / Math.pow(10, decimalsNum)).toString();
}

/**
 * Helper function to convert token amount to wei
 * @param amount - The token amount
 * @param decimals - The number of decimal places for the token
 * @returns The amount in wei as a string
 */
export function tokenAmountToWei(amount: string, decimals: number | bigint): string {
  const decimalsNum = typeof decimals === "bigint" ? Number(decimals) : decimals;

  // Handle the case where amount is already an integer
  if (!amount.includes(".") && !amount.includes("e") && !amount.includes("E")) {
    return (BigInt(amount) * BigInt(10 ** decimalsNum)).toString();
  }

  const [integerPart, decimalPart = ""] = amount.split(".");

  // Pad or truncate the decimal part to match the required decimals
  let paddedDecimalPart = decimalPart.padEnd(decimalsNum, "0");

  if (paddedDecimalPart.length > decimalsNum) {
    paddedDecimalPart = paddedDecimalPart.substring(0, decimalsNum);
  }

  const result = integerPart + paddedDecimalPart;

  // Remove leading zeros from the integer part
  const trimmedResult = result.replace(/^0+/, "") || "0";

  return trimmedResult;
}
